<template>
  <div class="market">
    <el-breadcrumb class="bread-nav" separator="/">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>爬虫管理</el-breadcrumb-item>
      <el-breadcrumb-item>市场专题</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="addBtnParent">
      <el-button class="addBtn" type="primary" icon="plus" size="small" @click="addCrawler()">添加</el-button>
    </div>
    <el-table :data="crawlerData" border stripe style="width: 100%">
      <el-table-column label="爬虫ID" width="80" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.crawlerId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="关键字" width="120" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.crawlerName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="爬取数据源" width="300" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.crawlerURL }}</span>
        </template>
      </el-table-column>
      <el-table-column label="专题名称" width="200" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.specialName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="模块名称" width="150" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.moduleName | filterModuleName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.creatDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center" fixed="right">
        <template scope="scope">
          <el-button class="crawlerBtn" size="small" v-show="scope.row.isDelete===0" type="success" @click="handleStart(scope.$index, scope.row)">开启</el-button>
          <el-button class="crawlerBtn" size="small" v-show="scope.row.isDelete===1" type="danger" @click="handleStop(scope.$index, scope.row)">关闭</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加市场专题爬虫" v-model="isDialogShow" size="small" top="20%" :modal-append-to-body="false" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="validateRules" label-width="80px">
        <el-form-item label="关键字" prop="crawlerName">
          <el-input v-model="form.crawlerName"></el-input>
        </el-form-item>
        <el-form-item label="数据源" prop="crawlerURL">
          <el-input v-model="form.crawlerURL"></el-input>
        </el-form-item>
        <el-form-item label="获取内容">
          <el-select v-model="form.classTypeName" placeholder="请选择获取内容">
            <el-option label="单图新闻" value="a.piece"></el-option>
            <el-option label="视频新闻" value="a.video-piece"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专题列表" prop="specialId">
          <el-select v-model.number="form.specialId" placeholder="请选择专题" @change="specialIdChange(form.specialId)">
            <el-option v-for="item in specialIds" :key="item.specialId" :label="item.specialName" :value="item.specialId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块列表" prop="moduleId">
          <el-select v-model.number="form.moduleId" placeholder="请选择模块">
            <el-option v-for="item in moduleIds" :key="item.moduleId" :label="item.moduleName" :value="item.moduleId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新闻类别" prop="newsTypeId">
          <el-select v-model.number="form.newsTypeId" placeholder="请选择新闻类别">
            <el-option v-for="item in newsTypeIds" :key="item.newsTypeId" :label="item.newsTypeName" :value="item.newsTypeId" :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="isDialogShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addBtn()">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import CONFIG from "@/config/index.js";
  import TOOL from '@/tool/index.js';
  import router from "@/router/index.js";
  import { mapGetters } from 'vuex';
  import co from 'co';
  export default {
    name: "crawlerBusiness",
    data() {
      return {
        crawlerData: null,
        isDialogShow:false,
        newsTypeIds:[],
        specialIds:[],
        moduleIds:[],
        form:{
          crawlerName:null,
          crawlerURL:'',
          classTypeName:'a.piece',
          specialId:'',
          moduleId:'',
          newsTypeId:''
        },
        validateRules: {
          crawlerName: [
            { validator: this._checkCraelerName, trigger: 'blur' }
          ],
          crawlerURL: [
            { validator: this._checkcrawlerURL, trigger: 'blur' }
          ],
          newsTypeId:[
            { required: true, message: '请选择新闻类型（目前只支持单图）'},
            { type: 'number', message: '请选择新闻类型必须为数字值'}
          ],
          moduleId:[
            { required: true, message: '请选择专题模块'},
            { type: 'number', message: '请选择新闻类型必须为数字值'}
          ],
          specialId:[
            { required: true, message: '请选择对应专题'},
            { type: 'number', message: '专题id必须为数字值'}
          ]
        },
      }
    },
    computed: {
      ...mapGetters({
          userInfo: 'getUserInfo'
        })
    },
    filters: {
        filterModuleName: function (value) {
            if (!value||!value.trim())
             return '默认模块';
            else
             return value;
        }
    },
    methods: {
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      specialIdChange(specialId){
          this.moduleIds=[];
          this.form.moduleId=null;
          this.$http.get(CONFIG.HOST + '/superSpecialModule/list/'+specialId)
          .then((result)=>{
              if(result.body.status===1){
                this.moduleIds=result.body.data;
                this.moduleIds.push({moduleId:-1,moduleName:"默认模块"});
                console.log(this.moduleIds);
              }else{
                this.$notify.error({
                    message: body.message
                });
              }
          })
          .catch((data)=>{
            this.$notify.error({
                message: data
            });
          });
      },
      addBtn(){
        let flag = true;
        this.$refs['form'].validate((valid) => {
          if (!valid) {
            flag = false;
            return false;
          }
        });
        if(!flag){
          return;
        }else{
          this._addBtnService();
        }
      },
      _addBtnService(){
          var self = this;
        var form = this.form;
        var formData = Object.create(null);
        formData.crawlerName = form.crawlerName.trim();
        formData.crawlerURL = form.crawlerURL.trim();
        formData.specialId = form.specialId;
        formData.newsTypeId = form.newsTypeId;
        formData.moduleId = form.moduleId<0?null:form.moduleId;
        formData.userId = this.userInfo.userId;
        this._addBtnCo(formData)()
          .catch(()=>{
            self.$notify.error({
              message: "添加失败"
            });
            self.resetForm('form');
        });
      },
      _addBtnCo:function(formData){
        var self = this;
        function* gen(){
          var result = yield self.$http.post(CONFIG.HOST + '/crawler/superSpecial/addCrawler',formData);
          if(result.body.status===1){
            self.isDialogShow=false;
            self._init();
            self.$notify.success({
              message: "添加成功"
            });
            self.resetForm('form');
          }else{
            self.$notify.error({
              message: result.body.message
            });
          }
        }
        return co.wrap(gen);
      },
      _checkCraelerName(rule, value, callback){
        if (!value||!value.trim()) {
          return callback(new Error('请输入关键字'));
        }else{
          callback();
        }
      },
      _checkcrawlerURL(rule, value, callback){
        var reg = /^https:\/\/www.yidianzixun.com\/channel/;
        if(!value||!reg.test(value)){
          return callback(new Error('请输入以https://www.yidianzixun.com/channel开头的数据源'));
        }else{
          callback();
        }
      },
      _disabledOtherNewsType(arr){
        for(let i=0;i<arr.length;i++){
          if(arr[i].newsTypeName!=='单图新闻'){
            arr[i].disabled = true;
          }
        }
        return arr;
      },
      addCrawler(){
        var self = this;
        Promise.all([this.$http.get(CONFIG.HOST + '/superSpecial/list'),this.$http.get(CONFIG.HOST + '/mkTemplate/list')])
        .then(([specialIds,newsTypeIds])=>{
          if(specialIds.body.status!==1){
            return Promise.reject(specialIds.body.message);
          }
          if(newsTypeIds.body.status!==1){
            return Promise.reject(newsTypeIds.body.message);
          }
          this.specialIds=specialIds.body.data;
          this.newsTypeIds=self._disabledOtherNewsType(newsTypeIds.body.data);
          return 1;
        })
        .catch((message)=>{
          this.isDialogShow=false;
          this.$notify.error({
            message: message
          });
        });
        this.isDialogShow=true;
      },
      //开启爬虫方法
      handleStart(index, row) {
        this.$confirm('确认是否开启该爬虫', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(()=>{
          return this.$http.put(CONFIG.HOST + '/crawler/special/startCrawler/'+row.crawlerId, {});
        })
        .then((resData)=>{
          var body = resData.body;
          if(body.status===1){
            row.isDelete=1;
          }else{
            this.$notify.error({
              message: body.message
            });
          }
        })
        .catch(()=>{});
      },
      //关闭爬虫方法
      handleStop(index, row) {
        this.$confirm('确认是否关闭该爬虫', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(()=>{
          return this.$http.put(CONFIG.HOST + '/crawler/special/stopCrawler/'+row.crawlerId, {});
        })
        .then((resData)=>{
          var body = resData.body;
          if(body.status===1){
            row.isDelete=0;
          }else{
            this.$notify.error({
              message: body.message
            });
          }
        })
      .catch(()=>{});
        console.log(index, row);
      },
      //组件进入工作状态的钩子函数
      _init(){
        this.$http.get(CONFIG.HOST + "/crawler/superSpecial/crawlerList" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.crawlerData = result.data;
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      }
    },
    mounted(){
      this._init();
    }
  };
</script>
<style lang="less">
  .market{
    width: 98%;
    margin: 0 auto;
    position: relative;
    .addCrawlerDialog{
      width: 60%;
      left: 60% !important;
      text-align: left;
    }
    .addBtnParent{
      width: 100%;
      text-align: right;
      margin-bottom: 3px;
    }
    .bread-nav{
      margin: 20px 0;
    }
    .crawlerBtn{
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Market.vue?5f273fe4